"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsolatableHybridConfigurationStore = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
/**
 * Extension of the HybridConfigurationStore that allows optionally isolating the serving store from
 * updates.
 * This could be useful when you want to avoid updating the serving store to maintain greater
 * consistency within a session, but still want to update the cache for a quick, updated
 * initialization the next session.
 */
class IsolatableHybridConfigurationStore extends js_client_sdk_common_1.HybridConfigurationStore {
    constructor(servingStore, persistentStore, servingStoreUpdateStrategy = 'always') {
        super(servingStore, persistentStore);
        this.servingStoreUpdateStrategy = servingStoreUpdateStrategy;
    }
    /** @Override */
    async setEntries(entries) {
        var _a;
        if (this.persistentStore) {
            // always update persistent store
            await this.persistentStore.setEntries(entries);
        }
        const persistentStoreIsExpired = !this.persistentStore || (await this.persistentStore.isExpired());
        const servingStoreIsEmpty = !((_a = this.servingStore.getKeys()) === null || _a === void 0 ? void 0 : _a.length);
        // Update the serving store based on the update strategy:
        // "always" - always update the serving store
        // "expired" - only update if the persistent store is expired
        // "empty" - only update if the persistent store is expired and the serving store is empty
        const updateServingStore = this.servingStoreUpdateStrategy === 'always' ||
            (persistentStoreIsExpired && this.servingStoreUpdateStrategy === 'expired') ||
            (persistentStoreIsExpired && servingStoreIsEmpty);
        if (updateServingStore) {
            this.servingStore.setEntries(entries);
        }
        return updateServingStore;
    }
}
exports.IsolatableHybridConfigurationStore = IsolatableHybridConfigurationStore;
//# sourceMappingURL=isolatable-hybrid.store.js.map